import { getDateInFormat } from "@domains/utils/reportDates";
import { toCamelCase } from "@domains/utils/stringMethods";
import React from "react";
import { Card, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { config } from "@frameworks/salesjourney/config/domain";
import ClientTier from "@frameworks/salesjourney/components/Generic/ClientTier";
import { getInterestedPriorityTag } from "@frameworks/salesjourney/components/constant";
var UpcomingActivities = function (props) {
    var _a, _b;
    var navigate = useNavigate();
    var routeLeadDashboard = function () {
        navigate("/dashboard/lead-dashboard?isExpiry=" + true + "&tabFlag=" + 2, {
            replace: true,
        });
    };
    var routeToEditLead = function (leadId) {
        if (leadId) {
            var editLeadURL = "/dashboard/leadpage/" + window.btoa(leadId);
            return editLeadURL;
        }
        else
            return "";
    };
    return (React.createElement(Card, { className: "upcoming-activities" },
        React.createElement(Card.Header, { className: "no_bg border-bottom-0 DMSanBold_18_700 txt-midnight-blue" }, "Upcoming Activities"),
        React.createElement(Card.Body, null,
            React.createElement(Row, { className: "DMSans_16_500 txt-midnight-blue bg_aqua_white today" }, "Today"),
            React.createElement("div", { className: "scroll-event commonscroll-new" },
                React.createElement(Row, { className: "txt_blackOne1 activity" },
                    React.createElement(Row, { className: "DMSans_16_500" }, "Meetings"),
                    props.upcomingMeetings && ((_a = props.upcomingMeetings) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (props.upcomingMeetings.map(function (eventRecord, idx) {
                        return (React.createElement("div", { className: "DMSanN_14_400 line-140 txt_black d-flex align-items-center" },
                            React.createElement("i", { className: "edel-icon-right-arrow" }),
                            React.createElement(Link, { className: " text-decoration-underline hand_cursor line-140 txt_black", to: routeToEditLead(eventRecord.leadId) },
                                getDateInFormat(eventRecord.meetingDate, "h:mmA") + " ",
                                " ",
                                ": ",
                                eventRecord.firstName),
                            React.createElement("div", { className: "d-flex p-0 flex-row align-items-center justify-content-center ms-2" },
                                (eventRecord === null || eventRecord === void 0 ? void 0 : eventRecord.clientTier) ? (React.createElement(ClientTier, { showOnlyIcon: true, clientTier: eventRecord === null || eventRecord === void 0 ? void 0 : eventRecord.clientTier })) : (React.createElement(React.Fragment, null)),
                                (eventRecord === null || eventRecord === void 0 ? void 0 : eventRecord.isCritical) ? (React.createElement("i", { className: "edel-icon-urgent-1" })) : (React.createElement(React.Fragment, null)),
                                (eventRecord === null || eventRecord === void 0 ? void 0 : eventRecord.interaction_priority_id) ? (getInterestedPriorityTag(eventRecord === null || eventRecord === void 0 ? void 0 : eventRecord.interaction_priority_id)) : (React.createElement(React.Fragment, null)))));
                    })) : (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "DMSanN_14_400 line-140" }, "No meetings Today")))),
                React.createElement(Row, { className: "txt_blackOne1 activity" },
                    React.createElement(Row, { className: "DMSans_16_500 line-140" }, "Expiring Leads"),
                    React.createElement(Row, { className: parseInt(props.totalExpiringLeads) > 0
                            ? "DMSanN_14_400 line-140 hand_cursor"
                            : "DMSanN_14_400 line-140" }, parseInt(props.totalExpiringLeads) > 0 ? (React.createElement("div", { className: " txt_black p-0" },
                        React.createElement("span", { className: "px-0 txt_black" },
                            "You Have ",
                            "",
                            React.createElement("a", { className: "common-link-child txt_black text-decoration-underline", href: config.applicationFolder +
                                    "dashboard/lead-dashboard?isExpiry=" +
                                    true +
                                    "&tabFlag=" +
                                    2 }, props.totalExpiringLeads),
                            "",
                            " Expiring Leads"))) : (React.createElement("span", { className: "px-0 txt_black" }, "You Have 0 Expiring Leads")))),
                React.createElement(Row, { className: "txt_blackOne1 activity border-bottom-0" },
                    React.createElement(Row, { className: "DMSans_16_500" }, "Events"),
                    ((_b = props.events) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (props.events.map(function (eventRecord, idx) {
                        if (idx < 4)
                            return (React.createElement("div", { className: "DMSanN_14_400 line-140" },
                                React.createElement("i", { className: "edel-icon-right-arrow" }),
                                eventRecord.accName,
                                "\u00A0\u00A0",
                                toCamelCase(eventRecord.eventName),
                                " "));
                    })) : (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "DMSanN_14_400 line-140" }, "No Events Today"))))))));
};
export default UpcomingActivities;
